import React from 'react'
import PropTypes from 'prop-types'

import { withStyles } from '@material-ui/core/styles'
import {
  IconButton,
  SvgIcon,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@material-ui/core'
import { mdiAccountMultiple } from '@mdi/js'
import Tooltip from '@material-ui/core/Tooltip'

import Link from '../controls/Link'
import EditButton from './EditButton'

const OrganizationRow = (p) => (
  <TableRow>
    <TableCell>{p.org.id}</TableCell>
    <TableCell>{p.org.name}</TableCell>
    <TableCell>
      <Tooltip title={`${p.org.name} Users`} placement="top">
        <span>
          <Link to={`/organizations/${p.org.id}/users`}>
            <IconButton aria-label="Users">
              <SvgIcon>
                <path d={mdiAccountMultiple} />
              </SvgIcon>
            </IconButton>
          </Link>
        </span>
      </Tooltip>
      <Tooltip title={`Edit ${p.org.name}`} placement="top">
        <span>
          <EditButton label={`Edit ${p.org.name}`} onClick={() => p.onEdit(p.org)} />
        </span>
      </Tooltip>
    </TableCell>
  </TableRow>
)

class OrganizationList extends React.Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    organizations: PropTypes.object.isRequired,
    onEdit: PropTypes.func.isRequired,
  }

  static styles = () => ({
    table: {
      width: 'auto',
    },
  })

  render() {
    return (
      <Table className={this.props.classes.table}>
        <TableHead>
          <TableRow>
            <TableCell>Id</TableCell>
            <TableCell>Name</TableCell>
            <TableCell />
          </TableRow>
        </TableHead>
        <TableBody>
          {Object.values(this.props.organizations).map((o) => (
            <OrganizationRow key={o.id} org={o} {...this.props} />
          ))}
        </TableBody>
      </Table>
    )
  }
}

export default withStyles(OrganizationList.styles)(OrganizationList)
